export function SkillsModel() {
    const model = {
        program: {
            show: true,
            required: false,
            param: {
                custom: false,
                saveCustom: false,
                variants: [],
            },
            level: {
                custom: false,
                saveCustom: false,
                variants: [],
            },
        },
        language: {
            show: true,
            required: false,
            param: {
                custom: false,
                saveCustom: false,
                variants: [],
            },
            level: {
                custom: false,
                saveCustom: false,
                variants: [],
            },
        },
    };

    return {
        data: model,
        update(fieldData) {
            if (!fieldData) return;
            const data = fieldData.skills;
            if (!data) return;

            ["program", "language"].forEach((skill) => {
                ["show", "required"].forEach((key) => {
                    model[skill][key] = data[skill][key];
                    model[skill][key] = data[skill][key];
                });

                ["param", "level"].forEach((param) => {
                    ["custom", "saveCustom"].forEach((key) => {
                        model[skill][param][key] = data[skill][param][key];
                    });
                });
            });
        },
        reset() {
            ["program", "language"].forEach((skill) => {
                model[skill].show = true;
                model[skill].required = false;

                ["param", "level"].forEach((param) => {
                    ["custom", "saveCustom"].forEach((key) => {
                        model[skill][param][key] = false;
                    });
                });
            });
        },
        setDictionaries(dictionaries) {
            const { programs, programLevels, languages, languageLevels } = dictionaries;

            if (programs) model.program.param.variants = programs;
            if (programLevels) model.program.level.variants = programLevels;
            if (languages) model.language.param.variants = languages;
            if (languageLevels) model.language.level.variants = languageLevels;
        },
        getDictionaries() {
            const { language, program } = model;
            return {
                programs: program.param.variants,
                programLevels: program.level.variants,
                languages: language.param.variants,
                languageLevels: language.level.variants,
            };
        },
        getData() {
            return { skills: model };
        },
    };
}
